// extracted by mini-css-extract-plugin
module.exports = {"tab":"LeftPublicNav_tab__1viJ2","nav":"LeftPublicNav_nav__2F4TO"};